import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Organization } from '@shared/models/organization/organization.model';
import { BaseRestApiService } from '@shared/services/base-rest-api.service';
import { RestApiWrapperService } from '@shared/services/rest-api-wrapper.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrganizationAdminService extends BaseRestApiService {
  public organizationUri = environment.serverUri + `api/${environment.apiVersion}/system-admin/organizations`;
  public organizationSearchUri = this.organizationUri + '/search';

  constructor(_restApiWrapperService: RestApiWrapperService) {
    super(_restApiWrapperService);
  }

  /**
   * Server-side filtered search. Hits the additive /search endpoint added in dt-api
   * (preserves the bare-path endpoint + its OAP_CLIENT access). Pass through the
   * filter/sort/page/size query params via `options.params`.
   *
   * Returns the raw Spring Data Page envelope: { content, totalElements, totalPages, ... }.
   * NOTE: the `true` third arg to `this.get(...)` is load-bearing. BaseRestApiService.get
   * auto-unwraps to `response.content` by default; we need the full envelope here so the
   * caller can read both `content` AND `totalElements` for ag-grid's server-side row count.
   * Mirrors UserAdminService.list(options).
   */
  public search(options: Object): Observable<any> {
    return this.get<any>(this.organizationSearchUri, options, true);
  }

  public createUpdate(organization: Organization): Observable<Organization> {
    if (organization.id) {
      return this.put<Organization>(`${this.organizationUri}/${organization.id}`, JSON.stringify(organization))
              .pipe(
                map(result => new Organization(result))
              );
    }
    return this.post<Organization>(this.organizationUri, JSON.stringify(organization))
            .pipe(
              map(result => new Organization(result))
            );
  }
}
